/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
Sai Maheshwar 11/25/2022 3031450488 added reportFields components
Guru Prasad 11/25/2022 3031450488 Fixed button alignments
Sohel 11/28/2022  3031450488 Added Date Format Field
Gummala Prakash 11/28/2022 3031450488 Fixed Button Alignment.
akhila 2/12/2022 3031450488 added Toaster for work-queue
Sai krishna 12/02/2022 2701350359 Fixed validation bug
Sai krishna 12/02/2022 2701350359 Fixed deleted ids bugs
Saikrishna 12/03/2022 3031450488 Fixed work queues account number field default.
Sai Maheshwar 12/03/2022 3031450488 added save and close in map fields
Sai Maheshwar 12/04/2022 2698948956 Added map fields save close buttons
Saikrishna 12/05/2022 3031450488 Fixed account field population issue.
Dilip 12/05/2022  3031450488 Removed unecesarry console.log statements
kavya9reddy 12/08/2022 3031450488 Added save button
//akhila 12/08/2022 3075234474 changed toast message workqueue to Work Queue
Sai maheshwar 12/08/2022 3031450488 fixed unsaved changes alert bug
Sohel 12/13/2022 3031450488 fixed duplicate fields Added Issue
Sohel 12/13/2022 3031450488 conditionally hide Save Button
Ashraf 12/13/2022 3031450488 deleted ids issue and save and stay
Suresh Peddavoora 12/16/2022 3031450488 Fixed save button alignments
sai Krishna 12/23/2022 3031450488 add Work Queue code, Reportcode  and Work Queue description,Report description
Akhila 01/09/2023 3031450488 Fixed Double loader issue in  Popup dialog box in search Field
Ashraf 01/23/2023 3031450488 Added field header exist validation.
Akhila 03/03/2023 2692790263 bug fixed prepoulation issue record in work queue fiel step
Sohel 04/14/2023 3031450488 Added Field Length Validation and Payload Changes
Sohel  04/25/2023 2701127043 Added Data Calculation Field
Guru Prasad  04/25/2023 2701127043 Fixed button alignments
Sohel 05/12/2023 2700753823 Fixed Reset Select Fields issue
Sohel 05/15/2023 2700753823 Fixed default Account Number prepopulate Issue
Sohel 06/01/2023 2700753823 Fixed WorkQueue Account Number Prepopulate issue
Sohel 06/01/2023 2700753823 Worked Queue Duplicate Account Number Issue
Phanee 06/02/2023 2700753823 Work Queue Duplicate Render Issue
Sohel 06/02/2023 2700753823 Fixed prepoppulate issue
Sohel 06/03/2023 2700799562 Added Amount Format and Data Type Field
Ravi 06/20/2023 2700753823 Added Breadcrum in popup
Ravi 07/19/2023 3031450488  added data Calculation map fields
Ravi 07/19/2023 3031450488 modifield sort field popup
Ravi 07/20/2023 3031450488 Removed maped data calculation from sorts field table
Sohel 10/16/2023 2698811066 Fixed Date Format issue
Sohel 10/16/2023 2698811066 Fixed Field Usage Issue
*/
import { Button } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import * as Yup from 'yup';
import SearchFields from '../../../FrameWorks/GlobalFields/DataRepositories/SearchDataRepositories/index';
import { useDispatch, useSelector } from 'react-redux';
import SearchDataCalculationFields from '../../../FrameWorks/BRE/FormulaRuleGroup/SearchRuleGroup';
import DialogBox from '../../../../components/DialogBox';
import {
  fetchWorkqueueFields,
  fetchBasicInfo,
  postWorkqueueFieldsDetails,
  resetMessage,
  resetReportFields,
  setReduxState,
} from '../../../../redux/reducers/WorkQueueSetup';
import { getFields } from '../../../FrameWorks/Reports/AddReport/Components/utils';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../components/CustomSnackBar';
import { getDropDownData } from '../../../../redux/reducers/BRE/AddReportMaster';
import { httpGet } from '../../../../util/Rest';
import { REPORTING_EXPORT, WORK_QUEUE_SETUP } from '../../../../constants/ReusableRoleAccess';
import BreadCrums from '../../../../util/BreadCrum';
import FieldTable from '../Components/FieldTable';
import PageLoader from '../../../../components/PageLoader';
import reusableInputStyles from '../../../../components/InputStyles';
import { submissionStart } from '../../../../redux/reducers/CommonActions/commonActions';

const WorkqueueFields = ({ handleNext, handleBack, workQueue, handleDirty, editExisting }) => {
  const {
    workQueueFieldsData,
    workQueueSortFieldsData,
    successMsg,
    isLoading,
    wqCode,
    errorMsg,
    reportFieldsPostStatus,
    basicInfoData,
    initialSave,
    reportDateStampFields,
  } = useSelector(({ addWorkQueue }) => addWorkQueue);
  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialVal = {
    field: '',
    name: '',
  };

  const [initialValues, setInitialValues] = useState(initialVal);
  const [mapFiledsDialog, setMapFieldListDialog] = useState(false);
  const [sortFiledsDialog, setSortFieldListDialog] = useState(false);
  const [dateStampDialog, setDateStampDialog] = useState(false);
  const workqueueFieldsDeletedIdsRef = useRef([]);
  const sortFieldsDeleteIdsRef = useRef([]);
  const dateStampFieldDeleteRef = useRef([]);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [mapDataCalculation, setMapDataCalculation] = useState(false);
  const [sortFields, setSortFields] = useState([]);
  const [dateStampFields, setDateStampFields] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const saveRef = useRef();
  const formRef = useRef();

  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  const handleDataCalculationFields = () => {
    setMapDataCalculation(false);
  };

  useEffect(() => {
    if (workQueueFieldsData?.length > 0) {
      const sortedSeq = [...workQueueFieldsData].sort((a, b) => a?.seqNum - b?.seqNum);
      const newSelectedRows = sortedSeq.map((el) => {
        const currField = el.fieldCode
          ? el.fieldCode + el.repositoryName
          : el.fieldName + el.repositoryName;
        const obj = { ...el };
        obj['sortSeqNum' + currField] = obj.sortSeqNum;
        obj['sortType' + currField] = obj.sortType;
        return {
          ...obj,
          fieldName: obj.fieldCode,
          ...getFields({ ...obj, fieldName: obj.fieldCode }),
        };
      });
      const initialVal = {};
      newSelectedRows?.forEach((r, i) => {
        const currField = r.fieldCode
          ? r.fieldCode + r.repositoryName
          : r.fieldName + r.repositoryName;
        initialVal['fieldHeader' + currField] = r?.fieldHeading
          ? r?.fieldHeading?.trim()
          : r.fieldLabel;
        initialVal['sortSeqNum' + currField] = r['sortSeqNum' + currField];
        initialVal['sortType' + currField] = r['sortType' + currField];
      });
      setInitialValues(initialVal);

      const uniqueArray = newSelectedRows.filter(
        (value, index, self) => index === self.findIndex((t) => t.fieldCode === value.fieldCode),
      );
      setSelectedRows(uniqueArray);
    }
  }, [workQueueFieldsData]);
  useEffect(() => {
    if (selectedRows?.length === 0 && workQueue && basicInfoData?.lastStep === 1) {
      const url = `workqueu/get/all/repofield`;
      httpGet(url).then((response) => {
        const currentArr = [...selectedRows];
        const res = response?.response || [];
        const defaultFieldsData = [...res];
        let obj = {};
        Array.isArray(defaultFieldsData) &&
          defaultFieldsData?.forEach((item, i) => {
            const isAccNoExists = currentArr?.filter((row) => {
              return row.fieldName == item.fieldName && row.repositoryName == item.repositoryName;
            });
            if (!isAccNoExists?.length) {
              currentArr.push({
                ...item,
                fieldName: item.fieldName,
                ...getFields({ ...item, fieldName: item.fieldName }),
              });
            }
            const currField = item.fieldCode
              ? item.fieldCode + item.repositoryName
              : item.fieldName + item.repositoryName;
            const dynamicfieldNameHeader = 'fieldHeader' + currField;
            const dynamicsortType = 'sortType' + currField;
            const dynamicsortSeqNum = 'sortSeqNum' + currField;
            obj = {
              ...obj,
              [dynamicfieldNameHeader]: item.fieldName,
              [dynamicsortType]: '',
              [dynamicsortSeqNum]: '',
            };
          });
        setInitialValues((prevState) => {
          return {
            ...prevState,
            ...obj,
          };
        });
        setSelectedRows(currentArr);
      });
      dispatch(fetchWorkqueueFields(wqCode));
    }
  }, [selectedRows, initialSave, basicInfoData]);
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    if (workQueueSortFieldsData?.length > 0) {
      const sortedSeq = [...workQueueSortFieldsData].sort((a, b) => a?.seqNum - b?.seqNum);
      const newSelectedRows = sortedSeq.map((el) => {
        return {
          ...el,
          fieldName: el.fieldCode,
          sortOrder: el.decending,
          printTotal: el.subtotal,
        };
      });
      setSortFields(newSelectedRows);
    } else {
      setSortFields([]);
    }
  }, [workQueueSortFieldsData]);

  useEffect(() => {
    if (reportDateStampFields?.length > 0) {
      const sortedSeq = [...reportDateStampFields].sort((a, b) => a?.seqNum - b?.seqNum);
      const newSelectedRows = sortedSeq.map((el) => {
        return {
          ...el,
          dateValue: el?.value?.replace('cast(now()as date)', 'TODAY'),
        };
      });
      setDateStampFields(newSelectedRows);
    } else {
      setDateStampFields([]);
    }
    if (reportDateStampFields?.length > 0) {
      const initialVal = {};
      const sortedSeq = [...reportDateStampFields].sort((a, b) => a?.seqNum - b?.seqNum);
      sortedSeq?.forEach((r, i) => {
        const currField = r.fieldName + r.repositoryName;
        initialVal['dateValue' + currField] = r?.value
          ? r?.value?.replace('cast(now()as date)', 'TODAY')
          : '';
      });
      setInitialValues((prev) => ({ ...prev, ...initialVal }));
    }
  }, [reportDateStampFields]);
  useEffect(() => {
    if (reportFieldsPostStatus === 200) {
      setTimeout(() => {
        dispatch(setReduxState({ property: 'initialSave', value: false }));
        dispatch(resetReportFields());
        dispatch(resetMessage());
        if (!saveRef.current) {
          handleNext();
        } else {
          workqueueFieldsDeletedIdsRef.current = [];
          sortFieldsDeleteIdsRef.current = [];
          dateStampFieldDeleteRef.current = [];
        }
        dispatch(fetchWorkqueueFields(wqCode));
      }, 2000);
    }
  }, [reportFieldsPostStatus]);
  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetReportFields());
      }, 2000);
    }
  }, [errorMsg, successMsg]);
  useEffect(() => {
    if (wqCode) {
      dispatch(fetchWorkqueueFields(wqCode));
      dispatch(fetchBasicInfo(wqCode));
    }
  }, [wqCode]);

  const shape = {};
  selectedRows?.forEach((r, i) => {
    const currField = r.fieldName + r.repositoryName;
    shape['fieldHeader' + currField] = Yup.string()
      .nullable()
      .required('Field Header is required')
      .test('fieldHeader' + currField, 'Field Header already exist', function (value) {
        const fieldHeaders = selectedRows?.map((i) => {
          if (i.fieldName + i.repositoryName !== r.fieldName + r.repositoryName) {
            return formRef?.current?.values['fieldHeader' + i.fieldName + i.repositoryName]?.trim();
          }
        });
        if (value && fieldHeaders?.includes(value?.trim())) {
          return false;
        } else {
          return true;
        }
      });

    shape['sortType' + currField] = Yup.string().test(
      'Sort type',
      'Sort type is required',
      (value, context) => {
        if (context.parent['sortSeqNum' + r.fieldName + r.repositoryName] && !value) {
          return false;
        } else {
          return true;
        }
      },
    );
    shape['sortSeqNum' + currField] = Yup.string()
      .nullable()
      .test('sortSeqNum' + currField, 'Sort Seq already exist', function (value, context) {
        const sortSeqNum = selectedRows?.map((i) => {
          if (i.fieldName + i.repositoryName !== r.fieldName + r.repositoryName) {
            const val = formRef?.current?.values['sortSeqNum' + i.fieldName + i.repositoryName];
            return val && Number(val);
          }
        });
        if (value && sortSeqNum?.includes(Number(value))) {
          return false;
        } else {
          return true;
        }
      });
  });

  const shape2 = {};
  dateStampFields?.forEach((r, i) => {
    const currField = r.fieldName + r.repositoryName;
    shape2['dateValue' + currField] = Yup.string().nullable().required('Date Stamp is required');
  });

  const validationSchema = Yup.object().shape({
    ...shape,
    ...shape2,
  });

  const handleClose = () => {
    setMapFieldListDialog(false);
  };

  const handleSortFieldDialog = () => {
    setSortFieldListDialog(false);
  };
  const handleDateStamDialog = () => {
    setDateStampDialog(false);
  };
  const { roleData } = useSelector(({ role }) => role);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS;
  const roleAccess =
    (workQueue &&
      (workQueueFieldsData?.length > 0 || workQueueSortFieldsData?.length > 0) &&
      !workQueueSetupAccess?.edit &&
      editExisting) ||
    (!workQueue &&
      (workQueueFieldsData?.length > 0 || workQueueSortFieldsData?.length > 0) &&
      !reportRoleAccess?.edit &&
      editExisting);
  const handleSubmit = (data) => {
    dispatch(submissionStart());
    const fieldsList = selectedRows?.map((r, i) => {
      const field = {};
      const currField = r.fieldName + r.repositoryName;
      field['seqNum'] = i + 1;
      field['fieldHeading'] = data['fieldHeader' + currField];
      field['workqueueFieldId'] = r.workqueueFieldId ? r.workqueueFieldId : 0;
      field['repositoryName'] = r.repositoryName;
      field['fieldCode'] = r.fieldName;
      field['sortSeqNum'] = data['sortSeqNum' + currField] ? data['sortSeqNum' + currField] : '';
      field['sortType'] = data['sortType' + currField] ? data['sortType' + currField] : '';
      return field;
    });
    const payload = {
      lastStep: saveRef.current ? 1 : 2,
      workQueueMapFieldsRequest: fieldsList,
      workqueueFieldDeleteIds: workqueueFieldsDeletedIdsRef.current,
      workqueueId: basicInfoData?.workqueueId ? basicInfoData?.workqueueId : 0,
      workqueueName: basicInfoData?.workqueueName ? basicInfoData?.workqueueName : '',
      // workqueueSortFieldDeleteIds: sortFieldsDeleteIdsRef.current,
    };
    // }
    dispatch(postWorkqueueFieldsDetails(payload));
    // }
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
        innerRef={formRef}
      >
        {(props) => {
          const { values, setFieldValue, errors, touched, handleChange } = props;
          return (
            <>
              <BreadCrums
                name={'Work Queue Name'}
                code={basicInfoData?.workqueueName}
                description={'Work Queue Description'}
                descriptionValue={basicInfoData?.workqueueDescription}
              />
              <Form noValidate>
                <div className=" new-standard-textfields table-header table-card-header justify-content-end">
                  <Button
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    onClick={() => setMapFieldListDialog(true)}
                    startIcon={<AccountTreeIcon />}
                  >
                    Map Fields
                  </Button>
                  <Button
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    onClick={() => setMapDataCalculation(true)}
                    startIcon={<AccountTreeIcon />}
                  >
                    Map Data Calculations Fields
                  </Button>
                  {/* )} */}
                </div>
                <FieldTable
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  isWorkQueue={true}
                  errors={errors}
                  workQueue={workQueue}
                  handleDirty={handleDirty}
                  reportFieldsDeleteIdsRef={workqueueFieldsDeletedIdsRef}
                  touched={touched}
                  values={values}
                  setFieldValue={setFieldValue}
                  handleChange={handleChange}
                  sortFields={sortFields}
                  setSortFields={setSortFields}
                  sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                />
                <div className="new-standard-textfields d-flex justify-content-center align-items-center mt-4">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    disabled={!selectedRows?.length || roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 ${classes.buttonRoot}`}
                    disabled={!selectedRows?.length || roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = false;
                    }}
                  >
                    Save & Next
                  </Button>
                </div>
                <DialogBox
                  hideBackdrop={true}
                  open={mapFiledsDialog}
                  dialogClose={handleClose}
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Map Fields</b>
                      </p>
                      <BreadCrums
                        name={'Work Queue Name'}
                        code={basicInfoData?.workqueueName}
                        description={'Work Queue Description'}
                        descriptionValue={basicInfoData?.workqueueDescription}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchFields
                    selectedRows={selectedRows}
                    setReportFieldValue={setFieldValue}
                    setSelectedRows={setSelectedRows}
                    isReports={true}
                    mapFields={true}
                    isWorkQueue={true}
                    workqueueFieldsDeletedIdsRef={workqueueFieldsDeletedIdsRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleClose}
                    setTempSelectedRows={setTempSelectedRows}
                    workQueue={workQueue}
                    moduleName={'WORK_QUEUE'}
                  />
                </DialogBox>
                <DialogBox
                  hideBackdrop={true}
                  open={mapDataCalculation}
                  dialogClose={handleDataCalculationFields}
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Map Fields</b>
                      </p>
                      <BreadCrums
                        name={'Work Queue Name'}
                        code={basicInfoData?.workqueueName}
                        description={'Work Queue Description'}
                        descriptionValue={basicInfoData?.workqueueDescription}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchDataCalculationFields
                    selectedRows={selectedRows}
                    setReportFieldValue={setFieldValue}
                    setSelectedRows={setSelectedRows}
                    isReports={true}
                    mapFields={true}
                    isWorkQueue={true}
                    workqueueFieldsDeletedIdsRef={workqueueFieldsDeletedIdsRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleDataCalculationFields={handleDataCalculationFields}
                    setTempSelectedRows={setTempSelectedRows}
                    workQueue={workQueue}
                  />
                </DialogBox>
                <DialogBox
                  hideBackdrop={true}
                  open={sortFiledsDialog}
                  dialogClose={handleSortFieldDialog}
                  // title="Search Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Fields</b>
                      </p>
                      <BreadCrums
                        name={'Work Queue Name'}
                        code={basicInfoData?.workqueueName}
                        description={'Work Queue Description'}
                        descriptionValue={basicInfoData?.workqueueDescription}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchFields
                    sortFields={sortFields}
                    setSortFields={setSortFields}
                    isReports={true}
                    reportFieldsDeleteIdsRef={workqueueFieldsDeletedIdsRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleSortFieldDialog}
                    handleDirty={handleDirty}
                    mapFields={true}
                    setTempSelectedRows={setTempSelectedRows}
                  />
                </DialogBox>
                <DialogBox
                  hideBackdrop={true}
                  open={dateStampDialog}
                  dialogClose={handleDateStamDialog}
                  // title="Search Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Fields</b>
                      </p>
                      <BreadCrums
                        name={'Work Queue Name'}
                        code={basicInfoData?.workqueueName}
                        description={'Work Queue Description'}
                        descriptionValue={basicInfoData?.workqueueDescription}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchFields
                    dateStampFields={dateStampFields}
                    setDateStampFields={setDateStampFields}
                    isReports={true}
                    reportFieldsDeleteIdsRef={workqueueFieldsDeletedIdsRef}
                    dateStampFieldDeleteRef={dateStampFieldDeleteRef}
                    sortFieldsDeleteIdsRef={sortFieldsDeleteIdsRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleDateStamDialog}
                    handleDirty={handleDirty}
                    mapFields={true}
                    setTempSelectedRows={setTempSelectedRows}
                    reportDateStamp={true}
                  />
                </DialogBox>
              </Form>
            </>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && (
        <SuccessSnackbar
          successMsg={
            workQueue ? 'Work Queue Fields Details added/modified Successfully' : successMsg
          }
        />
      )}
    </>
  );
};

export default React.memo(WorkqueueFields);
